module.exports = __webpack_public_path__ + "_assets/img/game-new.3a447c54.svg";